import { createAsyncThunk } from '@reduxjs/toolkit';
import { addSnackbar, deleteSnackbar } from './notifierReducer';

export const ENQUEUE_SNACKBAR = 'notifications/ENQUEUE_SNACKBAR';
export const REMOVE_SNACKBAR = 'notifications/REMOVE_SNACKBAR';
export const SNACKBAR_SOMETHING_WRONG = 'notifications/SNACKBAR_SOMETHING_WRONG';

export const enqueueSnackbar = createAsyncThunk(ENQUEUE_SNACKBAR, async (notification, { dispatch }) => {
  const key = notification.options && notification.options?.key;

  dispatch(
    addSnackbar({
      ...notification,
      key: key || new Date().getTime() + Math.random(),
    }),
  );
});

export const removeSnackbar = createAsyncThunk(REMOVE_SNACKBAR, async (key, { dispatch }) => {
  dispatch(deleteSnackbar(key));
});

export const somethingWrongNotification = createAsyncThunk(SNACKBAR_SOMETHING_WRONG, async (_, { dispatch }) => {
  dispatch(
    enqueueSnackbar({
      message: 'oopsSomethingWentWrong',
      options: {
        variant: 'warning',
        subMessage: 'pleaseTryAgainLaterContactSupportIfYouNeedHelp',
        showMarkerText: false,
        subMessageWithContactLink: true,
      },
    }),
  );
});
